






import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import AuthenticationWrapper from '@/components/Layout/Layouts/AuthenticationWrapper.vue';

@Component<ForgotPassword>({
  components: { AuthenticationWrapper },
})
export default class ForgotPassword extends Vue {
  tmpEmail = '';

  get email() {
    if (!this.tmpEmail) {
      const localStorageEmail = localStorage.getItem('email@forgot-password');
      if (localStorageEmail) {
        this.tmpEmail = localStorageEmail;
      }
    }
    return this.tmpEmail;
  }

  set email(val) {
    localStorage.setItem('email@forgot-password', val);
    this.tmpEmail = val;
  }
}
